import { render, staticRenderFns } from "./AnswerTypeMatrix.vue?vue&type=template&id=97e9e0b2&scoped=true"
import script from "./AnswerTypeMatrix.vue?vue&type=script&lang=js"
export * from "./AnswerTypeMatrix.vue?vue&type=script&lang=js"
import style0 from "./AnswerTypeMatrix.vue?vue&type=style&index=0&id=97e9e0b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e9e0b2",
  null
  
)

export default component.exports